export const EXTERNAL_PLATFORMS_FETCH_BEGIN = 'syftacp/EXTERNAL_PLATFORMS_FETCH_BEGIN'
export const EXTERNAL_PLATFORMS_FETCH_FAILED = 'syftacp/EXTERNAL_PLATFORMS_FETCH_FAILED'
export const EXTERNAL_PLATFORMS_FETCH_SUCCEEDED = 'syftacp/EXTERNAL_PLATFORMS_FETCH_SUCCEEDED'
